import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import useProduct from '../CustomHook/useProduct';

const Update = () => {
    const [relode, setRelode] = useState(false);
    const [products] = useProduct();
    const [product, setProduct] = useState({});
    const { quantity } = product;
    const { id } = useParams();
    useEffect(() => {
        fetch(`https://protected-plateau-21838.herokuapp.com/products/${id}`)
            .then(Response => Response.json())
            .then(data => {
                setProduct(data);
                setRelode(!relode)
            })

    }, [id, relode]);


    const handleQuantity = event => {
        event.preventDefault();

        const quantitys = event.target.name.value;
        console.log(quantitys)
        const inputQuantity = parseInt(quantitys);
        const newQuantity = quantity + inputQuantity;

        const url = `https://protected-plateau-21838.herokuapp.com/products/${id}`;
        fetch(url, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ newQuantity })
        })
            .then(res => res.json())
            .then(data => {
                event.target.reset();
            })

    }

    const handleReduce = (product) => {
        const rest = products.find(pd => pd._id === product._id)
        if (rest && rest.quantity >= 1) {
            rest.quantity = rest.quantity - 1;
            const decriseQuantity = rest.quantity;

            const url = `https://protected-plateau-21838.herokuapp.com/products/${id}`;
            fetch(url, {
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({ decriseQuantity })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                })
        }
    }


    return (
        <div className="col-md-5 mx-auto mt-5">

            <div style={{ height: '480px' }} class="shadow p-2 mb-3 bg-body rounded">
                <img style={{ height: '130px' }} src={product.img} alt="" />
                <h6 className='mt-2'>{product.name}</h6>
                <p class='m-0'>Price: ${product.price}</p>
                <p class='m-0'>Quantity: {quantity}</p>
                <p class='m-0'>Supplier: {product.supplier}</p>
                <p style={{ fontSize: '13px', textAlign: 'justify' }} class='m-0 mt-2'>{product.description}</p>

                <button onClick={() => handleReduce(product)} className='btn btn-primary text-white mt-1'>
                    Delever
                </button>

                {/* <form onSubmit={handleQuantity}>
                    <input className='border-1 pl-2 py-1' type="text" name="name" id="" placeholder='New Quantity' />
                    <input className='btn btn-primary fw-bold' type="submit" value="ReStock" />
                </form> */}


                <Form onSubmit={handleQuantity}>
                    <Form.Group className="mb-3 mt-4" controlId="formBasicEmail">
                        <Form.Control type="text" name='name' placeholder="Enter quantity" />
                    </Form.Group>
                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </div>
        </div >
    );
};

export default Update;